export default {"src":"/_next/static/media/Users.018a4854.svg","height":40,"width":41};